export const TAG_PREFIX = "location-";

// strip location- prefix for display
export function stripLocationPrefix(tags: string[]): string[] {
  return removeQuotes(
    tags.map((tag) => (tag.startsWith(TAG_PREFIX) ? tag.slice(TAG_PREFIX.length) : tag))
  );
}

// add location- prefix for backend
export function addLocationPrefix(tags: string[]): string[] {
  return tags.map((tag) => (tag.startsWith(TAG_PREFIX) ? tag : `${TAG_PREFIX}${tag}`));
}

// remove quotes from tags if they exist
export function removeQuotes(tags: string[]): string[] {
  return tags.map((tag) => tag.replace(/^(["'])(.*)\1$/, "$2"));
}
